import React, { useState } from 'react'
import Title from '../../../components/Title';
import { Button } from 'react-bootstrap';
import Icon from '../../../components/Icon';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Tabs from '../../../components/Tabs';
import General from '../../../components/app/admin/General';
import { useDeleteAppAdminMutation, useGetAppAdminQuery } from '../../../api/appAdminApiSlice';
import Version from '../../../components/app/admin/Version';
import EditAppModal from '../../../components/app/admin/EditAppModal';
import AppSubTitle from '../../../components/app/AppSubtitle';
import useDeleteConfirmation from '../../../components/useDeleteConfirmation';
import isEmpty from 'lodash/isEmpty';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const Admin = () => {
  const appId = useParams()["appId"];
	const { t } = useTranslation();
  const { data: app={}, isSuccess, isError, retry } = useGetAppAdminQuery(appId)
  const [deleteApp] = useDeleteAppAdminMutation();
  const handleEditClick = () => (setShowEdit(true));
  const history = useHistory();
  const [showEdit, setShowEdit] = useState(false)
  const {DeleteConfirmation, deleteConfirmationProps, confirm} = useDeleteConfirmation()

  const onDeleteApp = () => {
    deleteApp(appId).unwrap()
    .then(() => {
      history.push("/")
    })
  }

  const onDelete = () => {
    confirm("confirm", () => onDeleteApp())
  }

  return ( <>
    <Title main={(<AppSubTitle app={app}/>)} sub={t('app.admin')} group={true} backPath={`/apps/${appId}`}>
      <Button onClick={handleEditClick}>
        <Icon icon='edit' text={t("edit")} />
      </Button>
      <Button onClick={onDelete}>
        <Icon icon='trash' text={t("delete")} />
      </Button>
    </Title>
    { !isEmpty(app) && <EditAppModal show={showEdit} onClose={()=>(setShowEdit(false))} appId={appId}/>}
    <Tabs active={"app.general"}>
      <General icon={"home"} as={"app.general"} app={app} isSuccess={isSuccess} isError={isError} retry={retry} />
      <Version appId={appId} icon={"version"} as={"version"}/>
    </Tabs>
    <DeleteConfirmation
      placeholder={t("app.deletePlaceholder")}
      {...deleteConfirmationProps}
      confirmValue={t("app.confirm")}
    />
  </> );
}

export default Admin;
